import styled from 'styled-components';
import ResultCompoundImages from '../ResultCompoundImages';
import ResultInfo from '../ResultInfo';
import CloseButton from '../../common/CloseButton';
import { useDispatch } from 'react-redux';
import {
  setFirstDestination,
  setSecondDestination
} from '../../../../../redux/slices/mapSlice';

const MDistanceResult = () => {
  const dispatch = useDispatch();

  const closeDrawer = () => {
    dispatch(setFirstDestination(null));
    dispatch(setSecondDestination(null));
  };
  return (
    <Container>
      <div className="result">
        <ResultCompoundImages />

        <ResultInfo />
      </div>

      <CloseButton handleClick={closeDrawer} />
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  left: 50%;
  transform: translateX(-50%);
  gap: 8px;
  bottom: 32px;
  width: 90%;
  max-height: 103px;
  background-color: #f9fafb;
  border: 1px solid #f0f1f3;
  border-radius: 24px;
  backdrop-filter: blur(2px);
  box-shadow:
    0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 8px 16px 0px rgba(0, 0, 0, 0.08);
  padding: 16px;
  z-index: 10;

  .result {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export default MDistanceResult;
